import * as React from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Collapse from "@mui/material/Collapse";
import { Grid, Typography } from "@mui/material";
import { TextItem } from "../elements/text-item";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "app/theme-context";

interface ISpecification {
    [propName: string]: { value: string; type: string };
}

interface IComponentProps {
    specification: ISpecification;
}

const SPECIFICATION_NAME_KEY = "entry_text";
const SPECIFICATION_IRI_KEY = "entry_iri";
const OMMITED_ATTRIBUTES = [SPECIFICATION_NAME_KEY, SPECIFICATION_IRI_KEY];

export const SpecificationDetails = (props: IComponentProps) => {
    const [isExpanded, setExpanded] = React.useState(true);
    const { cssProperties } = useTheme();
    const { specification } = props;
    const toggle = () => setExpanded(!isExpanded);

    const formatKey = (key: string) => {
        return key.replaceAll("_", " ");
    };

    const renderRow = (key: string, value: string) => {
        if (OMMITED_ATTRIBUTES.includes(key) || !value) {
            return null;
        }
        return (
            <Grid container key={key} spacing={2} style={{ paddingTop: 10 }}>
                <Grid size={4} sx={{ textTransform: "uppercase", fontSize: "12px", p: 0 }}>
                    {formatKey(key)}
                </Grid>
                <Grid size={8}>
                    <TextItem text={value} copyToClipboard />
                </Grid>
            </Grid>
        );
    };

    return (
        <Card>
            <CardHeader
                title={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Typography variant="body1">
                            <Link
                                to={
                                    "?uri=" +
                                    encodeURIComponent(specification[SPECIFICATION_IRI_KEY].value)
                                }
                                style={{
                                    ...cssProperties,
                                    ...{
                                        textDecoration: "underline"
                                    }
                                }}
                            >
                                {specification[SPECIFICATION_NAME_KEY].value}
                            </Link>
                        </Typography>
                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                }
                onClick={toggle}
                sx={{
                    ...cssProperties,
                    ...{
                        cursor: "pointer"
                    }
                }}
            />
            <Collapse in={isExpanded}>
                <CardContent>
                    {Object.keys(specification).map((key: any) =>
                        renderRow(key, specification[key].value)
                    )}
                </CardContent>
            </Collapse>
        </Card>
    );
};
